// src/utils/mapProduct.js
import { PRODUCT_TAGS } from "../data/products";

export function mapBackendProduct(p) {
  const tags = [];

if (p.is_new_in) tags.push(PRODUCT_TAGS.NEW_IN);
if (p.is_bestseller) tags.push(PRODUCT_TAGS.BESTSELLER);
if (p.is_quickly_sold_out) tags.push("QUICKLY_SOLD_OUT");

if (Array.isArray(p.tags)) {
  p.tags.forEach((t) => t && tags.push(String(t)));
} else if (typeof p.tags === "string") {
  p.tags
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean)
    .forEach((t) => tags.push(t));
}

  let images = [];

  if (Array.isArray(p.images)) {
    images = p.images;
  } else if (typeof p.images === "string") {
    try {
      const parsed = JSON.parse(p.images);
      if (Array.isArray(parsed)) images = parsed;
    } catch (e) {}
  }

  if (!images.length) {
    images = ["/assets/logo.jpg"];
  }

  const variantList = Array.isArray(p.variants) ? p.variants : [];

const mappedSizes =
  Array.isArray(p.sizes) && p.sizes.length
    ? p.sizes
    : variantList
        .map((v) => v.size)
        .filter((size, index, arr) => size && arr.indexOf(size) === index);

const mappedColors =
  Array.isArray(p.colors) && p.colors.length
    ? p.colors
    : variantList
        .filter((v) => v.color_name || v.color_hex)
        .reduce((acc, v) => {
          const key = `${v.color_name || ""}-${v.color_hex || ""}`;
          if (!acc.some((x) => x.key === key)) {
            acc.push({
              key,
              name: v.color_name || "",
              code: v.color_hex || "#8B3A2F",
            });
          }
          return acc;
        }, []);

  return {
    id: p.id,
    public_id: p.public_id,
    slug: p.seo_slug,

    nameEN: p.name_en,
    nameAR: p.name_ar,

    is_new:
  p.is_new_in === 1 ||
  p.is_new_in === true,

is_bestseller:
  p.is_bestseller === 1 ||
  p.is_bestseller === true,

is_quickly_sold_out:
  p.is_quickly_sold_out === 1 ||
  p.is_quickly_sold_out === true ||
  p.quickly_sold_out === 1 ||
  p.quickly_sold_out === true ||
  p.isQuicklySoldOut === true,

is_new_in:
  p.is_new_in === 1 ||
  p.is_new_in === true,

dimensionsCompositionEN: p.short_desc_en || p.dimensions_composition_en || "",
dimensionsCompositionAR: p.short_desc_ar || p.dimensions_composition_ar || "",

    price: Number(p.base_price),
    discount: p.on_sale ? Number(p.sale_percent) : 0,

    totalStock: Number(p.total_stock) || 0,
    tags,

    sizes: mappedSizes.map((s) => ({
  size: s,
  inStock: true,
})),

colors: mappedColors.map((c) => ({
  name: c.name || c.color_name || "",
  code: c.code || c.color_hex || "#8B3A2F",
})),

    images,

    category: p.primary_category || null,
    categories: p.categories || [],

    ageRange: p.age_range || null,

    hasBxgy: p.has_bxgy || false,
    bxgyRole: p.bxgy_role || null,
    bxgyDetails: p.bxgy_details || [],
  };
}

